import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';

export default angular.module('auth-routing', []).config([
  '$stateProvider',
  function configuration($stateProvider) {
    $stateProvider
      .state('auth-changePassword', {
        parent: 'arw',
        url: '/change-password',
        template: `<change-password
                        model="appCtrl.appFactory.model"
                        api="$resolve.api"
                        ></change-password>`,
        params: {
          skipDirtyForms: false,
          email: null,
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Change Password')));
            },
          ],
        },
        resolve: {
          api: [
            'appFactory',
            'appApi',
            (appFactory) => ({
              config: appFactory.deps.config,
              resetSession: appFactory.dispatch('auth.resetSession', true),
              validateField: appFactory.uiHelpers.validateField,
            }),
          ],
        },
      })
      .state('auth-resetPassword', {
        parent: 'arw',
        url: '/forgot-passwd',
        template: '<forgot-password/>',
        redirectTo: 'permissions-denied',
        params: {
          hideMenu: true,
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Forgot Password')));
            },
          ],
        },
      })
      .state('auth-forgotUsername', {
        parent: 'arw',
        url: '/forgot-username',
        template: `<forgot-username
                    model="appCtrl.appFactory.model"
                    api="$resolve.api">
                    </forgot-username>`,
        redirectTo: 'permissions-denied',
        params: {
          hideMenu: true,
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Forgot Email')));
            },
          ],
        },
        resolve: {
          api: [
            'appFactory',
            'appApi',
            (appFactory) => ({
              config: appFactory.deps.config,
              remindUsername: appFactory.dispatch('auth.remindUsername', true),
            }),
          ],
        },
      })
      .state('user-logout', {
        parent: 'arw',
        url: '/logout',
        params: {
          pageTitle: [
            '$ngRedux',
            ($ngRedux) => {
              $ngRedux.dispatch(changePageTitle(null));
            },
          ],
        },
        resolve: {
          logout: [
            'appFactory',
            '$state',
            'toastr',
            (appFactory, $state, toastr) => {
              toastr.clear();
              const registrationConfirm = $state.current.name === 'registration-complete';
              return appFactory.dispatch('auth.logout', true).run(registrationConfirm);
            },
          ],
        },
      });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/auth/auth-routing-module.js